<a (click)='onClickFileName({item:item, fieldDefinition: fieldDefinition})' style="display: flex!important;"
   [analyticsAction]="item.cells[fieldDefinition.key]?.displayText" analyticsCategory="file-name-cell-viewer"
   class="link-color w-p-100 flex flex-row justify-start items-center" particleAnalytics>
    <div class="m-r-10">
        <!--<img
          alt="{{item.cells['Icon'].value}}"
          src="{{ 'https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/icons/orbitaxdriveicons/' + item.cells['Icon'].value + '.svg'}}">-->
        <div class="{{item.cells['Icon'].value}}"
             [ngClass]="{'background-opacity': item.cells['IsHidden'].value}"></div>
    </div>
    <div class="drive-file-name flex flex-row justify-start items-center full-grow-no-shrink-no-basis ">
        <div class="ellipse full-grow-no-shrink-no-basis "
             matTooltip="{{item.cells[fieldDefinition.key]?.displayText}}">
            {{item.cells[fieldDefinition.key]?.displayText}}
        </div>
        <i [matTooltip]="'Add to Starred'"
           (click)="markStar();$event.stopPropagation()"
           *ngIf="item.cells['ParentId']?.value !=='trash' && item.cells['Type']?.value !== 'SharedDrives' && item.cells['Type']?.value !== 'SharedDrive'  && item.cells['Type']?.value !== 'PersonalDrive' && !item.cells['IsFavorite']?.value"
           class="far fa-star"></i>
        <i [matTooltip]="'Remove from Starred'"
           (click)="markStar();$event.stopPropagation()"
           *ngIf="item.cells['ParentId']?.value !=='trash' && item.cells['Type']?.value !== 'SharedDrives' && item.cells['Type']?.value !== 'SharedDrive'  && item.cells['Type']?.value !== 'PersonalDrive'"
           [ngStyle]="{display:item.cells['IsFavorite']?.value? 'block': 'none' }"
           class="fas fa-star"></i>
    </div>
</a>
